import React, { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { PackageOverviewTabs } from './PackageOverviewTabs';
import { PackagesService } from '../../service';
import { packagesSlice } from '../../../../../store/brand/packagesSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { openCalendlyPopup } from '../../../../../shared/functions/Functions';
import { IAllStates } from '../../../../../store/rootReducer';

interface IPackageOverviewModalProps {
    show: boolean;
    closeModal: () => void;
}

export function PackageOverviewModal({ show, closeModal }: IPackageOverviewModalProps) {
    const dispatch = useDispatch();
    const { selectedPackage } = useSelector((states: IAllStates) => states.packages);
    const { t } = useTranslation();

    useEffect(() => {
        PackagesService.getPackages().then(response => {
            const data = response.data;
            dispatch(packagesSlice.actions.setAllPackages(data));
        });
    }, []);

    return (
        <Modal
            show={show}
            onHide={closeModal}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            id="packages-modal"
        >
            <Modal.Header className="border-bottom">
                <h5 className="mb-0">Subscription packages</h5>
            </Modal.Header>
            <Modal.Body className="pt-1">
                <PackageOverviewTabs />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={closeModal} className="mr-2" variant="outline-primary">
                    {t('general.button.cancel')}
                </Button>
                <Button onClick={() => openCalendlyPopup(String(process.env.VITE_PACKAGE_UPGRADE_CALENDLY))}>
                    {selectedPackage?.isSelected ? t('general.button.details') : t('general.button.upgrade')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
